export const COLLAPSED_TREE_KEY = '__collapsed__';
export const PANEL_TYPE = 'Run Comparer';
export const DESIRED_ORDER = ['meta', 'config', 'summary', 'histograms'];
